import Typography from "@material-ui/core/Typography";
import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import {Box, FormControl, Grid, InputLabel, Select, TextField} from "@material-ui/core";
import {useEffect, useState} from "react";
import CashUsers from "../CashUsers/CashUsers";
import {convertCurrencyFormat, convertToBirthDate, convertToMobileNumber} from "../../utils/numberConvertor";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {AccountsListService} from "../../component/ListOfAccounts/AccountsListService";


const AddNewAccount = ({openDialog, handleClickOpen, handleClose, needRefresh}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new AccountsListService(fundID, token, snackbar, loading)

    const [state, setState] = useState(1);
    const [subTitleMessage, setSubTitleMessage] = useState("");
    const [nextStateButtonTitle, setNextStateButtonTitle] = useState("");
    const [backBtnTitle, setBackBtnTitle] = useState("");

    const [headerFieldTitle, setHeaderFieldTitle] = useState("");

    //userInfoState
    const [userId, setUserId] = useState(-1);
    const [userNameLastName, setUserNameLastName] = useState("");
    const [userPersonalCode, setUserPersonalCode] = useState("");
    const [userPhoneNumber, setUserPhoneNumber] = useState("");
    const [userGroupName, setUserGroupName] = useState("");

    const [userCashAmount, setUserCashAmount] = useState("");
    const [userCashCode, setUserCashCode] = useState("");
    const [userCashBaneState, setUserCashBaneState] = useState(false);
    const [userCashActiveState, setUserCashActiveState] = useState(true);
    const [openedAt, setOpenedAt] = useState("");

    //executorInfoState
    const [executorId, setExecutorId] = useState(-1);
    const [executorNameLastName, setExecutorNameLastName] = useState("");
    const [executorPersonalCode, setExecutorPersonalCode] = useState("");
    const [executorPhoneNumber, setExecutorPhoneNumber] = useState("");
    const [executorGroupName, setExecutorGroupName] = useState("");


    useEffect(() => {
        switch (state) {
            case 1 :
                setSubTitleMessage("لطفا عضو مورد نظر را انتخاب نمایید.")
                setHeaderFieldTitle("لطفا عضو مورد نظر را انتخاب نمایید.")
                setNextStateButtonTitle("ثبت و ادامه")
                setBackBtnTitle("بازگشت")
                break;
            case 2 :
                setSubTitleMessage("لطفا قیم حساب را انتخاب نمایید.")
                setHeaderFieldTitle("لطفا قیم حساب را انتخاب نمایید.")
                setNextStateButtonTitle("ثبت و ادامه")
                setBackBtnTitle("بازگشت به انتخاب عضو")
                break;
            case 3 :
                setSubTitleMessage("لطفا اطلاعات حساب را تکمیل نمایید.")
                setNextStateButtonTitle("ثبت و افزودن حساب")
                setBackBtnTitle("بازگشت به انتخاب قیم")
                break;
            default:
                setSubTitleMessage("")
                setNextStateButtonTitle("ثبت و ادامه")
                setBackBtnTitle("بازگشت")
        }

    }, [state])

    useEffect(() => {
        if (openDialog) {
            clearUserFields()
            clearExecutorFields()
            clearCashAccountFields()
            setState(1)
        }

    }, [openDialog])


    function handleBackClicked() {
        switch (state) {
            case 1:
                handleClose()
                break
            case 2:
                setState(1)
                break
            case 3:
                setState(2)
                break
            default:
                setState(1)
        }
    }

    function handleGoNextStateClicked() {
        switch (state) {
            case 1:
                if (userId >= 0)
                    setState(2)
                else
                    snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا کاربر مورد نظر را انتخاب نمایید!"))
                break
            case 2:
                setState(3)
                break
            case 3: {
                doChange()
                break
            }
            default:
                setState(1)
        }
    }

    function doChange() {
        if (openedAt.length === 10) {
            needRefresh(true)
            service.addNewAccount(
                fundID,
                userId,
                userCashCode,
                executorId,
                userCashAmount,
                openedAt,
                userCashActiveState,
                clearFields,
                handleClose
            )
        } else
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا تاریخ ایجاد حساب را به درستی وارد نمایید!"))

    }

    function clearFields() {
        clearUserFields()
        clearExecutorFields()
        clearCashAccountFields()
        needRefresh(true)
        setState(1)
    }

    function selectUserRowClicked(rowInfo) {
        if (state === 1) {
            setUserId(rowInfo.id)
            setUserNameLastName(rowInfo.name)
            setUserPhoneNumber(rowInfo.phoneNumber)
            setUserPersonalCode(rowInfo.personalCode)
            setUserGroupName(rowInfo.group)

        } else if (state === 2) {
            setExecutorId(rowInfo.id)
            setExecutorNameLastName(rowInfo.name)
            setExecutorPhoneNumber(rowInfo.phoneNumber)
            setExecutorPersonalCode(rowInfo.personalCode)
            setExecutorGroupName(rowInfo.group)

        }
    }

    function handleIgnoreExecutorCashAccount() {
        clearExecutorFields()
        setState(3)
    }

    function clearUserFields() {
        setUserId(-1)
        setUserNameLastName("")
        setUserPhoneNumber("")
        setUserPersonalCode("")
        setUserGroupName("")
        setUserCashCode("")
    }

    function clearExecutorFields() {
        setExecutorId(-1)
        setExecutorNameLastName("")
        setExecutorPersonalCode("")
        setExecutorPhoneNumber("")
        setExecutorGroupName("")
    }

    function clearCashAccountFields() {
        setUserCashAmount("")
        setUserCashBaneState(false)
        setUserCashActiveState(true)
        setOpenedAt("")
    }

    return (
        <Dialog fullScreen
                onClose={handleClose}
                aria-labelledby="customized-dialog-title" open={openDialog}
                id="customized-full-screen-dialog">
            <section className="pageContainer">
                <Box className="transactionHeader">
                    <section className="transactionTitle">
                        <Grid xs={12} sm={12} md={8} lg={8} xl={8}
                              className="d-flex flex-column flex-nowrap justifyContentCenter">
                            <section className="d-flex flex-column w-100">
                                <ol className="c-stepper">
                                    <li className={`c-stepper__item ${state > 1 ? "active activeNext" : state === 1 ? "active" : ""}`}>
                                        <span className="c-stepper__desc">مالک حساب</span>
                                    </li>
                                    <li className={`c-stepper__item ${state > 2 ? "active activeNext" : state === 2 ? "active" : ""}`}>
                                        <span className="c-stepper__desc">قیم حساب</span>
                                    </li>
                                    <li className={`c-stepper__item ${state >= 3 ? "active" : ""}`}>
                                        <span className="c-stepper__desc">اطلاعات حساب</span>
                                    </li>

                                </ol>
                            </section>
                        </Grid>
                        <Grid xs={12} sm={12} md={4} lg={4} xl={4} className="d-flex flex-row justifyContentEnd mt-2">
                            <Grid>
                                <button className="btn-secondary me-2 " onClick={handleBackClicked}>
                                    {backBtnTitle}
                                </button>
                            </Grid>
                            <Grid>
                                <button className={`${state === 2 ? "btn-secondary me-2" : "d-none"}`}
                                        onClick={handleIgnoreExecutorCashAccount}>
                                    بدون قیم حساب
                                </button>
                            </Grid>
                            <Grid>
                                <button className="btn-confirm" onClick={handleGoNextStateClicked}>
                                    {nextStateButtonTitle}
                                </button>
                            </Grid>
                        </Grid>
                    </section>
                    <Box style={{display: "flex", flexWrap: "wrap"}} className={`${state === 3 ? "d-none" : ""}`}>
                        <Grid xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
                            <Typography variant={"subtitle1"} style={{paddingBottom: '8px'}}>
                                {headerFieldTitle}
                            </Typography>
                        </Grid>
                        <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                            <TextField
                                value={state === 1 ? userNameLastName : executorNameLastName}
                                disabled={true}
                                className='w-100'
                                variant="outlined" label="نام و نام خانوادگی"/>
                        </Grid>
                        <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                            <TextField
                                value={state === 1 ? userPersonalCode : executorPersonalCode}
                                className='w-100'
                                disabled={true}
                                dir={"ltr"}
                                variant="outlined" label="کد ملی"/>
                        </Grid>
                        <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                            <TextField
                                value={convertToMobileNumber(state === 1 ? userPhoneNumber : executorPhoneNumber)}
                                className='w-100'
                                disabled={true}
                                dir={"ltr"}
                                variant="outlined" label="شماره همراه"/>
                        </Grid>
                        <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                            <TextField
                                value={state === 1 ? userGroupName : executorGroupName}
                                className='w-100'
                                disabled={true}
                                variant="outlined" label="گروه"/>
                        </Grid>
                    </Box>
                </Box>
                <Box className="d-flex flex-column mt-2" style={{padding: "0.5rem 3rem", overflowY: "auto"}}>
                    {state === 1 || state === 2 ?
                        <CashUsers
                            isMain={false}
                            rowOnClicked={selectUserRowClicked}/> :
                        <Box className="d-flex flex-row flex-wrap w-100">
                            <Grid xs={12} xl={12} className="w-100 p-2">
                                <Typography variant={"subtitle1"} style={{paddingBottom: '8px'}}>
                                    مشخصات مالک حساب
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={userNameLastName}
                                    disabled={true}
                                    className='w-100'
                                    variant="outlined" label="نام و نام خانوادگی"/>
                            </Grid>
                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={userPersonalCode}
                                    className='w-100'
                                    disabled={true}
                                    dir={"ltr"}
                                    variant="outlined" label="کد ملی"/>
                            </Grid>
                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={convertToMobileNumber(userPhoneNumber)}
                                    className='w-100'
                                    disabled={true}
                                    dir={"ltr"}
                                    variant="outlined" label="شماره همراه"/>
                            </Grid>
                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={userGroupName}
                                    className='w-100'
                                    disabled={true}
                                    variant="outlined" label="گروه"/>
                            </Grid>

                            <Grid xs={12} xl={12} className="w-100 p-2">
                                <Typography variant={"subtitle1"} style={{paddingBottom: '8px'}}>
                                    مشخصات قیم حساب
                                </Typography>
                            </Grid>

                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={executorNameLastName}
                                    disabled={true}
                                    className='w-100'
                                    variant="outlined" label="نام و نام خانوادگی قیم حساب"/>
                            </Grid>

                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={executorPersonalCode}
                                    className='w-100'
                                    disabled={true}
                                    variant="outlined" label="کد ملی قیم حساب"/>
                            </Grid>

                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={convertToMobileNumber(executorPhoneNumber)}
                                    className='w-100'
                                    disabled={true}
                                    dir="ltr"
                                    variant="outlined" label="شماره همراه قیم حساب"/>
                            </Grid>


                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={executorGroupName}
                                    className='w-100'
                                    disabled={true}
                                    variant="outlined" label="گروه قیم حساب"/>
                            </Grid>

                            <Grid xs={12} xl={12} className="w-100 p-2">
                                <Typography variant={"subtitle1"} style={{paddingBottom: '8px'}}>
                                    اطلاعات حساب
                                </Typography>
                            </Grid>

                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={convertCurrencyFormat(userCashAmount)}
                                    onChange={e => {
                                        const num = e.target.value.replaceAll(",", "")
                                        setUserCashAmount(num)
                                    }}
                                    className='w-100'
                                    dir={"ltr"}
                                    variant="outlined" label="موجودی اولیه (ریال)"/>
                            </Grid>
                            <Grid xs={12} sm={6} md={3} lg={3} xl={3} className="w-100 p-2">
                                <TextField
                                    value={convertCurrencyFormat(userCashCode)}
                                    onChange={e => {
                                        const num = e.target.value.replaceAll(",", "")
                                        setUserCashCode(num)
                                    }}
                                    className='w-100'
                                    dir={"ltr"}
                                    variant="outlined" label="شماره حساب"/>
                            </Grid>

                            <Grid sm={12} md={3} lg={3} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="تاریخ افتتاح حساب"
                                           value={convertToBirthDate(openedAt)}
                                           onChange={e => {
                                               setOpenedAt(convertToBirthDate(e.target.value))
                                           }}/>

                            </Grid>

                            <Grid sm={12} md={3} lg={3} xl={3} className='p-2 w-100'>
                                <label id='residenceStatus' className="toggle-switch-content">
                                    <span className="toggle-title">فعال/غیرفعال</span>
                                    <label className="switch" htmlFor="MainCategory">
                                        <input
                                            type="checkbox"
                                            id="residenceStatus"
                                            checked={userCashActiveState}
                                            onChange={e => {
                                                setUserCashActiveState(e.target.checked)
                                            }}
                                        />
                                        <span className="toggle round"/>
                                    </label>

                                </label>
                            </Grid>

                        </Box>}
                </Box>

            </section>
        </Dialog>

    )
};

export default AddNewAccount;